// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partnership__info[data-v-71c85d7f]{font-size:18px;line-height:130%}.partnership__contact-form[data-v-71c85d7f]{display:flex;flex-direction:column;gap:20px;margin-top:40px}.partnership__btn[data-v-71c85d7f]{width:100%}.partnership__success[data-v-71c85d7f]{background:#52674c;border:1px solid #52674c;border-radius:6px;color:#fff;padding:13px 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
